const question5 = {
    'question': 'Jakie są wskazania do stosowania terapii EMDR?',
    'answer': 'Warto rozważyć terapię EMDR, jeśli doświadczasz takich objawów jak: koszmary senne, flashbacki, unikanie miejsc i osób związanych z traumą, trudności z koncentracją, poczucie przytłoczenia. Terapia EMDR jest skuteczną metodą leczenia PTSD i innych zaburzeń związanych z traumą. Pomaga zmniejszyć objawy związane z traumą i poprawić jakość życia.',
}

export default question5;